module.exports = __webpack_public_path__ + "media/images/landing/pro_icon-15dabab77f5b23272a4a55d6b7967e28.png";